import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';
import {CookieService} from 'ngx-cookie-service';
import {UserService} from '../service/user.service';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit {

  constructor(public apiService: ApiService,
              public userService: UserService,
              public cookieService: CookieService) {
  }

  ngOnInit() {
  }
}
